import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchTcmProjectRecords } from "../TcmService";
import DataGridTcmProjects from "./DataGridTcmProjects";
import { LoadingPanel } from "../../components/LoadingPanel";

const TcmProjectList = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState();

    useEffect(() => {
        loadTcmProjectCostEstimates();
    }, []);

    const loadTcmProjectCostEstimates = async () => {
        setLoading(true);
        try {
            const dataFetch = await fetchTcmProjectRecords();
            setData(
                dataFetch
            );
        } catch (error) {
            setError(error.message || "Error loading TCM Project Cost Estimates.");
        }
        setLoading(false);
    }

    return (
        <>
            {error && <p>Something went wrong.</p>}
            {loading && !data && <LoadingPanel location={{ of: '#tcm-project-cost-estimate-list' }} message="Loading TCM Project Cost Estimates..." />}
            <div id='tcm-project-cost-estimate-list'>
                {!loading && <DataGridTcmProjects dataSource={data}/>}
            </div>
        </>
    )
}
export default TcmProjectList;